/**
 * TAM Declarations API Client
 * Epic 71: Futáros Kézbesítés & TAM
 */

import { api } from './client';

// ============================================
// TYPES
// ============================================

export type TamDeclarationMethod = 'APP' | 'EMAIL' | 'PAPER';

export interface TamDeclaration {
  id: string;
  tenantId: string;
  invoiceId: string;
  declaredBy: string;
  method: TamDeclarationMethod;
  declaredAt: string;
}

export interface CreateTamDeclarationInput {
  invoiceId: string;
  method: TamDeclarationMethod;
}

export interface TamValidationResult {
  valid: boolean;
  hasTamItems: boolean;
  tamItemCount: number;
  declarationRequired: boolean;
  hasDeclaration: boolean;
  errors: string[];
}

export interface ValidateTamInvoiceInput {
  invoiceId: string;
  partnerId: string;
  status: string;
  items: Array<{
    productId: string;
    name: string;
    isTam: boolean;
    quantity: number;
    unitPrice: number;
    vatRate: number;
  }>;
}

// ============================================
// API CALLS
// ============================================

export async function createTamDeclaration(input: CreateTamDeclarationInput) {
  return api.post<{ data: TamDeclaration }>('/tam/declarations', input);
}

export async function listTamDeclarations() {
  return api.get<{ data: TamDeclaration[] }>('/tam/declarations');
}

export async function getTamDeclaration(id: string) {
  return api.get<{ data: TamDeclaration }>(`/tam/declarations/${id}`);
}

export async function validateTamInvoice(input: ValidateTamInvoiceInput) {
  return api.post<{ data: TamValidationResult }>('/tam/validate-invoice', input);
}
